module.exports = __webpack_public_path__ + "static/media/banner3.15da70d0.jpg";